module.exports = __webpack_public_path__ + "static/media/neworder.4acd0b1.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp3/neworder.mp3
// module id = 8dpd
// module chunks = 4